import { EditMinuteState } from "./EditMinutesState";
var EditHourState = /** @class */ (function () {
    function EditHourState() {
        this.toString = function () {
            return "Edit Hours";
        };
    }
    EditHourState.prototype.handleMode = function (watch) {
        watch.setState(new EditMinuteState());
    };
    EditHourState.prototype.handleIncrease = function (watch) {
        watch.getTimeOffset().hours += 1;
    };
    return EditHourState;
}());
export { EditHourState };
